import React, { useState } from 'react';
import { WalletTransactionTable } from '../..';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { DatePicker, SelectInput } from '../../../Components';
import './Style.css';
const Index = () => {
    const [pincode, setPincode] = useState('All');
    const [rowPerPage, setRowPerPage] = useState(10);
    return (
        <div className="wallet_transaction">
            <div className="wallet_transaction_head">
                <div className="wallet_transaction_date">
                    <p className="wallet_transaction_para">Choose Date</p>
                    <DatePicker />
                </div>
                <div className="wallet_transaction_select">
                    <SelectInput
                        label="Delivery Pincode"
                        outlined={true}
                        value={pincode}
                        changeHandler={(e) => {
                            setPincode(e.target.value);
                        }}
                        options={[
                            { name: 'All', value: 'All' },
                            { name: 'Some', value: 'S' },
                        ]}
                    />
                </div>
                <div className="wallet_transaction_button">
                    <button style={{ marginRight: '1rem' }} type="submit" className="btn-orange">
                        <p>Apply</p>
                    </button>
                    <button type="reset" className="btn-gray">
                        <p>Clear</p>
                    </button>
                </div>
                <p className="wallet_transaction_balance">Wallet Balance: ₹0</p>
            </div>
            <WalletTransactionTable />
            <div className="pagination_footer">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SelectInput
                        marginZero
                        style={{ minWidth: '30px' }}
                        label="Rows per page:"
                        value={rowPerPage}
                        changeHandler={(e) => {
                            setRowPerPage(e.target.value);
                        }}
                        options={[
                            { name: '10', value: 10 },
                            { name: '25', value: 25 },
                            { name: '50', value: 50 },
                        ]}
                    />
                </div>
                <div className="pagination_footer_pageinfo">
                    <p className="page_details">1-10 of 50</p>
                    <div>
                        <ChevronLeftIcon className={`footer_pagination_icon disabled`} />
                        <ChevronRightIcon className={`footer_pagination_icon`} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
